module.exports = __webpack_public_path__ + "static/media/sub_morelike2.13c1fa68.png";